import { Alert as MuiAlert, type AlertProps } from '@mui/material';
type Props = AlertProps & {
  wiggle?: boolean;
};

export const Alert = ({ wiggle, ...rest }: Props) => {
  return (
    <MuiAlert
      sx={({ animations }) =>
        wiggle
          ? {
              animation: `${animations.wiggle} .5s ease-in-out`,
              animationDelay: '300ms',
            }
          : {}
      }
      {...rest}
    />
  );
};
